const theme = {
  screens: {
    sm: '380px',
    md: '481px',
    lg: '769px',
    xl: '1041px',
    '2xl': '1350px',
  },
  screensRaw: { sm: 380, md: 481, lg: 769, xl: 1041, '2xl': 1350 },
  colors: {
    white: 'var(--white)',
    fg_primary: 'var(--fg-color-primary)',
    fg_secondary: 'var(--fg-color-secondary)',
    bg_primary: 'var(--bg-color-primary)',
    'grey-border': '#f0e9e9',
    'bg_ligth-grey-gradient': 'var(--bg-ligth-grey-gradient)',
    'grey-table-border': 'var(--grey-table-border)',
  },
  fontSize: {
    xs: '.75rem',
    sm: '.875rem',
    tiny: '.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '4rem',
    '7xl': '5rem',
  },
  boxShadow: { DEFAULT: '0 5px 17px rgba(109 77 77 / 17%)' },
  borderRadius: { DEFAULT: '4px' },
  maxWidth: {
    0: '0rem',
    none: 'none',
    xs: '20rem',
    sm: '24rem',
    md: '28rem',
    lg: '32rem',
    xl: '36rem',
    '2xl': '42rem',
    '3xl': '48rem',
    '4xl': '56rem',
    '5xl': '64rem',
    '6xl': '72rem',
    '7xl': '80rem',
    full: '100%',
    min: 'min-content',
    max: 'max-content',
    prose: '65ch',
    'screen-sm': '380px',
    'screen-md': '481px',
    'screen-lg': '769px',
    'screen-xl': '1041px',
    'screen-2xl': '1350px',
    '1/4': '25%',
    '1/2': '50%',
    '3/4': '75%',
  },
  container: {
    padding: { DEFAULT: '6%', sm: '6%', lg: '6%', xl: '8%', '2xl': '8%' },
  },
  spacing: {
    0: '0px',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
    px: '1px',
    0.5: '0.125rem',
    1.5: '0.375rem',
    2.5: '0.625rem',
    3.5: '0.875rem',
  },
  animation: {
    none: 'none',
    spin: 'spin 1s linear infinite',
    ping: 'ping 1s cubic-bezier(0, 0, 0.2, 1) infinite',
    pulse: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
    bounce: 'bounce 1s infinite',
  },
  backdropBlur: {
    0: '0',
    sm: '4px',
    DEFAULT: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    '2xl': '40px',
    '3xl': '64px',
  },
  backdropBrightness: {
    0: '0',
    50: '.5',
    75: '.75',
    90: '.9',
    95: '.95',
    100: '1',
    105: '1.05',
    110: '1.1',
    125: '1.25',
    150: '1.5',
    200: '2',
  },
  backdropContrast: {
    0: '0',
    50: '.5',
    75: '.75',
    100: '1',
    125: '1.25',
    150: '1.5',
    200: '2',
  },
  backdropGrayscale: { 0: '0', DEFAULT: '100%' },
  backdropHueRotate: {
    0: '0deg',
    15: '15deg',
    30: '30deg',
    60: '60deg',
    90: '90deg',
    180: '180deg',
    '-180': '-180deg',
    '-90': '-90deg',
    '-60': '-60deg',
    '-30': '-30deg',
    '-15': '-15deg',
  },
  backdropInvert: { 0: '0', DEFAULT: '100%' },
  backdropOpacity: {
    0: '0',
    5: '0.05',
    10: '0.1',
    20: '0.2',
    25: '0.25',
    30: '0.3',
    40: '0.4',
    50: '0.5',
    60: '0.6',
    70: '0.7',
    75: '0.75',
    80: '0.8',
    90: '0.9',
    95: '0.95',
    100: '1',
  },
  backdropSaturate: { 0: '0', 50: '.5', 100: '1', 150: '1.5', 200: '2' },
  backdropSepia: { 0: '0', DEFAULT: '100%' },
  backgroundColor: {
    white: 'var(--white)',
    fg_primary: 'var(--fg-color-primary)',
    fg_secondary: 'var(--fg-color-secondary)',
    bg_primary: 'var(--bg-color-primary)',
    'grey-border': '#f0e9e9',
    'bg_ligth-grey-gradient': 'var(--bg-ligth-grey-gradient)',
    'grey-table-border': 'var(--grey-table-border)',
  },
  backgroundOpacity: {
    0: '0',
    5: '0.05',
    10: '0.1',
    20: '0.2',
    25: '0.25',
    30: '0.3',
    40: '0.4',
    50: '0.5',
    60: '0.6',
    70: '0.7',
    75: '0.75',
    80: '0.8',
    90: '0.9',
    95: '0.95',
    100: '1',
  },
  backgroundPosition: {
    bottom: 'bottom',
    center: 'center',
    left: 'left',
    'left-bottom': 'left bottom',
    'left-top': 'left top',
    right: 'right',
    'right-bottom': 'right bottom',
    'right-top': 'right top',
    top: 'top',
  },
  backgroundSize: { auto: 'auto', cover: 'cover', contain: 'contain' },
  blur: {
    0: '0',
    sm: '4px',
    DEFAULT: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    '2xl': '40px',
    '3xl': '64px',
  },
  brightness: {
    0: '0',
    50: '.5',
    75: '.75',
    90: '.9',
    95: '.95',
    100: '1',
    105: '1.05',
    110: '1.1',
    125: '1.25',
    150: '1.5',
    200: '2',
  },
  borderColor: {
    white: 'var(--white)',
    fg_primary: 'var(--fg-color-primary)',
    fg_secondary: 'var(--fg-color-secondary)',
    bg_primary: 'var(--bg-color-primary)',
    'grey-border': '#f0e9e9',
    'bg_ligth-grey-gradient': 'var(--bg-ligth-grey-gradient)',
    'grey-table-border': 'var(--grey-table-border)',
    DEFAULT: 'currentColor',
  },
  borderOpacity: {
    0: '0',
    5: '0.05',
    10: '0.1',
    20: '0.2',
    25: '0.25',
    30: '0.3',
    40: '0.4',
    50: '0.5',
    60: '0.6',
    70: '0.7',
    75: '0.75',
    80: '0.8',
    90: '0.9',
    95: '0.95',
    100: '1',
  },
  borderWidth: { 0: '0px', 2: '2px', 4: '4px', 8: '8px', DEFAULT: '1px' },
  contrast: {
    0: '0',
    50: '.5',
    75: '.75',
    100: '1',
    125: '1.25',
    150: '1.5',
    200: '2',
  },
  cursor: {
    auto: 'auto',
    default: 'default',
    pointer: 'pointer',
    wait: 'wait',
    text: 'text',
    move: 'move',
    help: 'help',
    'not-allowed': 'not-allowed',
  },
  divideColor: {
    white: 'var(--white)',
    fg_primary: 'var(--fg-color-primary)',
    fg_secondary: 'var(--fg-color-secondary)',
    bg_primary: 'var(--bg-color-primary)',
    'grey-border': '#f0e9e9',
    'bg_ligth-grey-gradient': 'var(--bg-ligth-grey-gradient)',
    'grey-table-border': 'var(--grey-table-border)',
    DEFAULT: 'currentColor',
  },
  divideOpacity: {
    0: '0',
    5: '0.05',
    10: '0.1',
    20: '0.2',
    25: '0.25',
    30: '0.3',
    40: '0.4',
    50: '0.5',
    60: '0.6',
    70: '0.7',
    75: '0.75',
    80: '0.8',
    90: '0.9',
    95: '0.95',
    100: '1',
  },
  divideWidth: { 0: '0px', 2: '2px', 4: '4px', 8: '8px', DEFAULT: '1px' },
  dropShadow: {
    sm: '0 1px 1px rgba(0,0,0,0.05)',
    DEFAULT: ['0 1px 2px rgba(0, 0, 0, 0.1)', '0 1px 1px rgba(0, 0, 0, 0.06)'],
    md: ['0 4px 3px rgba(0, 0, 0, 0.07)', '0 2px 2px rgba(0, 0, 0, 0.06)'],
    lg: ['0 10px 8px rgba(0, 0, 0, 0.04)', '0 4px 3px rgba(0, 0, 0, 0.1)'],
    xl: ['0 20px 13px rgba(0, 0, 0, 0.03)', '0 8px 5px rgba(0, 0, 0, 0.08)'],
    '2xl': '0 25px 25px rgba(0, 0, 0, 0.15)',
    none: '0 0 #0000',
  },
  fill: { current: 'currentColor' },
  grayscale: { 0: '0', DEFAULT: '100%' },
  hueRotate: {
    0: '0deg',
    15: '15deg',
    30: '30deg',
    60: '60deg',
    90: '90deg',
    180: '180deg',
    '-180': '-180deg',
    '-90': '-90deg',
    '-60': '-60deg',
    '-30': '-30deg',
    '-15': '-15deg',
  },
  invert: { 0: '0', DEFAULT: '100%' },
  flex: { 1: '1 1 0%', auto: '1 1 auto', initial: '0 1 auto', none: 'none' },
  flexGrow: { 0: '0', DEFAULT: '1' },
  flexShrink: { 0: '0', DEFAULT: '1' },
  fontFamily: {
    sans: [
      'ui-sans-serif',
      'system-ui',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      '"Noto Sans"',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
      '"Noto Color Emoji"',
    ],
    serif: [
      'ui-serif',
      'Georgia',
      'Cambria',
      '"Times New Roman"',
      'Times',
      'serif',
    ],
    mono: [
      'ui-monospace',
      'SFMono-Regular',
      'Menlo',
      'Monaco',
      'Consolas',
      '"Liberation Mono"',
      '"Courier New"',
      'monospace',
    ],
  },
  fontWeight: {
    thin: '100',
    extralight: '200',
    light: '300',
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    extrabold: '800',
    black: '900',
  },
  gap: {
    0: '0px',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
    px: '1px',
    0.5: '0.125rem',
    1.5: '0.375rem',
    2.5: '0.625rem',
    3.5: '0.875rem',
  },
  gradientColorStops: {
    white: 'var(--white)',
    fg_primary: 'var(--fg-color-primary)',
    fg_secondary: 'var(--fg-color-secondary)',
    bg_primary: 'var(--bg-color-primary)',
    'grey-border': '#f0e9e9',
    'bg_ligth-grey-gradient': 'var(--bg-ligth-grey-gradient)',
    'grey-table-border': 'var(--grey-table-border)',
  },
  gridAutoColumns: {
    auto: 'auto',
    min: 'min-content',
    max: 'max-content',
    fr: 'minmax(0, 1fr)',
  },
  gridAutoRows: {
    auto: 'auto',
    min: 'min-content',
    max: 'max-content',
    fr: 'minmax(0, 1fr)',
  },
  gridColumn: {
    auto: 'auto',
    'span-1': 'span 1 / span 1',
    'span-2': 'span 2 / span 2',
    'span-3': 'span 3 / span 3',
    'span-4': 'span 4 / span 4',
    'span-5': 'span 5 / span 5',
    'span-6': 'span 6 / span 6',
    'span-7': 'span 7 / span 7',
    'span-8': 'span 8 / span 8',
    'span-9': 'span 9 / span 9',
    'span-10': 'span 10 / span 10',
    'span-11': 'span 11 / span 11',
    'span-12': 'span 12 / span 12',
    'span-full': '1 / -1',
  },
  gridColumnEnd: {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
    10: '10',
    11: '11',
    12: '12',
    13: '13',
    auto: 'auto',
  },
  gridColumnStart: {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
    10: '10',
    11: '11',
    12: '12',
    13: '13',
    auto: 'auto',
  },
  gridRow: {
    auto: 'auto',
    'span-1': 'span 1 / span 1',
    'span-2': 'span 2 / span 2',
    'span-3': 'span 3 / span 3',
    'span-4': 'span 4 / span 4',
    'span-5': 'span 5 / span 5',
    'span-6': 'span 6 / span 6',
    'span-full': '1 / -1',
  },
  gridRowStart: {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    auto: 'auto',
  },
  gridRowEnd: {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    auto: 'auto',
  },
  gridTemplateColumns: {
    1: 'repeat(1, minmax(0, 1fr))',
    2: 'repeat(2, minmax(0, 1fr))',
    3: 'repeat(3, minmax(0, 1fr))',
    4: 'repeat(4, minmax(0, 1fr))',
    5: 'repeat(5, minmax(0, 1fr))',
    6: 'repeat(6, minmax(0, 1fr))',
    7: 'repeat(7, minmax(0, 1fr))',
    8: 'repeat(8, minmax(0, 1fr))',
    9: 'repeat(9, minmax(0, 1fr))',
    10: 'repeat(10, minmax(0, 1fr))',
    11: 'repeat(11, minmax(0, 1fr))',
    12: 'repeat(12, minmax(0, 1fr))',
    none: 'none',
  },
  gridTemplateRows: {
    1: 'repeat(1, minmax(0, 1fr))',
    2: 'repeat(2, minmax(0, 1fr))',
    3: 'repeat(3, minmax(0, 1fr))',
    4: 'repeat(4, minmax(0, 1fr))',
    5: 'repeat(5, minmax(0, 1fr))',
    6: 'repeat(6, minmax(0, 1fr))',
    none: 'none',
  },
  height: {
    0: '0px',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
    auto: 'auto',
    px: '1px',
    0.5: '0.125rem',
    1.5: '0.375rem',
    2.5: '0.625rem',
    3.5: '0.875rem',
    '1/2': '50%',
    '1/3': '33.333333%',
    '2/3': '66.666667%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/5': '20%',
    '2/5': '40%',
    '3/5': '60%',
    '4/5': '80%',
    '1/6': '16.666667%',
    '2/6': '33.333333%',
    '3/6': '50%',
    '4/6': '66.666667%',
    '5/6': '83.333333%',
    full: '100%',
    screen: '100vh',
  },
  inset: {
    0: '0px',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
    auto: 'auto',
    px: '1px',
    0.5: '0.125rem',
    1.5: '0.375rem',
    2.5: '0.625rem',
    3.5: '0.875rem',
    '-0': '0px',
    '-1': '-0.25rem',
    '-2': '-0.5rem',
    '-3': '-0.75rem',
    '-4': '-1rem',
    '-5': '-1.25rem',
    '-6': '-1.5rem',
    '-7': '-1.75rem',
    '-8': '-2rem',
    '-9': '-2.25rem',
    '-10': '-2.5rem',
    '-11': '-2.75rem',
    '-12': '-3rem',
    '-14': '-3.5rem',
    '-16': '-4rem',
    '-20': '-5rem',
    '-24': '-6rem',
    '-28': '-7rem',
    '-32': '-8rem',
    '-36': '-9rem',
    '-40': '-10rem',
    '-44': '-11rem',
    '-48': '-12rem',
    '-52': '-13rem',
    '-56': '-14rem',
    '-60': '-15rem',
    '-64': '-16rem',
    '-72': '-18rem',
    '-80': '-20rem',
    '-96': '-24rem',
    '-px': '-1px',
    '-0.5': '-0.125rem',
    '-1.5': '-0.375rem',
    '-2.5': '-0.625rem',
    '-3.5': '-0.875rem',
    '1/2': '50%',
    '1/3': '33.333333%',
    '2/3': '66.666667%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    full: '100%',
    '-1/2': '-50%',
    '-1/3': '-33.333333%',
    '-2/3': '-66.666667%',
    '-1/4': '-25%',
    '-2/4': '-50%',
    '-3/4': '-75%',
    '-full': '-100%',
  },
  keyframes: {
    spin: { to: { transform: 'rotate(360deg)' } },
    ping: { '75%, 100%': { transform: 'scale(2)', opacity: '0' } },
    pulse: { '50%': { opacity: '.5' } },
    bounce: {
      '0%, 100%': {
        transform: 'translateY(-25%)',
        animationTimingFunction: 'cubic-bezier(0.8,0,1,1)',
      },
      '50%': {
        transform: 'none',
        animationTimingFunction: 'cubic-bezier(0,0,0.2,1)',
      },
    },
  },
  letterSpacing: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0em',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em',
  },
  lineHeight: {
    3: '.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    none: '1',
    tight: '1.25',
    snug: '1.375',
    normal: '1.5',
    relaxed: '1.625',
    loose: '2',
  },
  listStyleType: { none: 'none', disc: 'disc', decimal: 'decimal' },
  margin: {
    0: '0px',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
    auto: 'auto',
    px: '1px',
    0.5: '0.125rem',
    1.5: '0.375rem',
    2.5: '0.625rem',
    3.5: '0.875rem',
    '-0': '0px',
    '-1': '-0.25rem',
    '-2': '-0.5rem',
    '-3': '-0.75rem',
    '-4': '-1rem',
    '-5': '-1.25rem',
    '-6': '-1.5rem',
    '-7': '-1.75rem',
    '-8': '-2rem',
    '-9': '-2.25rem',
    '-10': '-2.5rem',
    '-11': '-2.75rem',
    '-12': '-3rem',
    '-14': '-3.5rem',
    '-16': '-4rem',
    '-20': '-5rem',
    '-24': '-6rem',
    '-28': '-7rem',
    '-32': '-8rem',
    '-36': '-9rem',
    '-40': '-10rem',
    '-44': '-11rem',
    '-48': '-12rem',
    '-52': '-13rem',
    '-56': '-14rem',
    '-60': '-15rem',
    '-64': '-16rem',
    '-72': '-18rem',
    '-80': '-20rem',
    '-96': '-24rem',
    '-px': '-1px',
    '-0.5': '-0.125rem',
    '-1.5': '-0.375rem',
    '-2.5': '-0.625rem',
    '-3.5': '-0.875rem',
  },
  maxHeight: {
    0: '0px',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
    px: '1px',
    0.5: '0.125rem',
    1.5: '0.375rem',
    2.5: '0.625rem',
    3.5: '0.875rem',
    full: '100%',
    screen: '100vh',
  },
  minHeight: { 0: '0px', full: '100%', screen: '100vh' },
  minWidth: { 0: '0px', full: '100%', min: 'min-content', max: 'max-content' },
  objectPosition: {
    bottom: 'bottom',
    center: 'center',
    left: 'left',
    'left-bottom': 'left bottom',
    'left-top': 'left top',
    right: 'right',
    'right-bottom': 'right bottom',
    'right-top': 'right top',
    top: 'top',
  },
  opacity: {
    0: '0',
    5: '0.05',
    10: '0.1',
    20: '0.2',
    25: '0.25',
    30: '0.3',
    40: '0.4',
    50: '0.5',
    60: '0.6',
    70: '0.7',
    75: '0.75',
    80: '0.8',
    90: '0.9',
    95: '0.95',
    100: '1',
  },
  order: {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
    10: '10',
    11: '11',
    12: '12',
    first: '-9999',
    last: '9999',
    none: '0',
  },
  outline: {
    none: ['2px solid transparent', '2px'],
    white: ['2px dotted white', '2px'],
    black: ['2px dotted black', '2px'],
  },
  padding: {
    0: '0px',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
    px: '1px',
    0.5: '0.125rem',
    1.5: '0.375rem',
    2.5: '0.625rem',
    3.5: '0.875rem',
  },
  placeholderColor: {
    white: 'var(--white)',
    fg_primary: 'var(--fg-color-primary)',
    fg_secondary: 'var(--fg-color-secondary)',
    bg_primary: 'var(--bg-color-primary)',
    'grey-border': '#f0e9e9',
    'bg_ligth-grey-gradient': 'var(--bg-ligth-grey-gradient)',
    'grey-table-border': 'var(--grey-table-border)',
  },
  placeholderOpacity: {
    0: '0',
    5: '0.05',
    10: '0.1',
    20: '0.2',
    25: '0.25',
    30: '0.3',
    40: '0.4',
    50: '0.5',
    60: '0.6',
    70: '0.7',
    75: '0.75',
    80: '0.8',
    90: '0.9',
    95: '0.95',
    100: '1',
  },
  ringColor: {
    DEFAULT: '#3b82f6',
    white: 'var(--white)',
    fg_primary: 'var(--fg-color-primary)',
    fg_secondary: 'var(--fg-color-secondary)',
    bg_primary: 'var(--bg-color-primary)',
    'grey-border': '#f0e9e9',
    'bg_ligth-grey-gradient': 'var(--bg-ligth-grey-gradient)',
    'grey-table-border': 'var(--grey-table-border)',
  },
  ringOffsetColor: {
    white: 'var(--white)',
    fg_primary: 'var(--fg-color-primary)',
    fg_secondary: 'var(--fg-color-secondary)',
    bg_primary: 'var(--bg-color-primary)',
    'grey-border': '#f0e9e9',
    'bg_ligth-grey-gradient': 'var(--bg-ligth-grey-gradient)',
    'grey-table-border': 'var(--grey-table-border)',
  },
  ringOffsetWidth: { 0: '0px', 1: '1px', 2: '2px', 4: '4px', 8: '8px' },
  ringOpacity: {
    0: '0',
    5: '0.05',
    10: '0.1',
    20: '0.2',
    25: '0.25',
    30: '0.3',
    40: '0.4',
    50: '0.5',
    60: '0.6',
    70: '0.7',
    75: '0.75',
    80: '0.8',
    90: '0.9',
    95: '0.95',
    100: '1',
    DEFAULT: '0.5',
  },
  ringWidth: {
    0: '0px',
    1: '1px',
    2: '2px',
    4: '4px',
    8: '8px',
    DEFAULT: '3px',
  },
  rotate: {
    0: '0deg',
    1: '1deg',
    2: '2deg',
    3: '3deg',
    6: '6deg',
    12: '12deg',
    45: '45deg',
    90: '90deg',
    180: '180deg',
    '-180': '-180deg',
    '-90': '-90deg',
    '-45': '-45deg',
    '-12': '-12deg',
    '-6': '-6deg',
    '-3': '-3deg',
    '-2': '-2deg',
    '-1': '-1deg',
  },
  saturate: { 0: '0', 50: '.5', 100: '1', 150: '1.5', 200: '2' },
  scale: {
    0: '0',
    50: '.5',
    75: '.75',
    90: '.9',
    95: '.95',
    100: '1',
    105: '1.05',
    110: '1.1',
    125: '1.25',
    150: '1.5',
  },
  sepia: { 0: '0', DEFAULT: '100%' },
  skew: {
    0: '0deg',
    1: '1deg',
    2: '2deg',
    3: '3deg',
    6: '6deg',
    12: '12deg',
    '-12': '-12deg',
    '-6': '-6deg',
    '-3': '-3deg',
    '-2': '-2deg',
    '-1': '-1deg',
  },
  space: {
    0: '0px',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
    px: '1px',
    0.5: '0.125rem',
    1.5: '0.375rem',
    2.5: '0.625rem',
    3.5: '0.875rem',
    '-0': '0px',
    '-1': '-0.25rem',
    '-2': '-0.5rem',
    '-3': '-0.75rem',
    '-4': '-1rem',
    '-5': '-1.25rem',
    '-6': '-1.5rem',
    '-7': '-1.75rem',
    '-8': '-2rem',
    '-9': '-2.25rem',
    '-10': '-2.5rem',
    '-11': '-2.75rem',
    '-12': '-3rem',
    '-14': '-3.5rem',
    '-16': '-4rem',
    '-20': '-5rem',
    '-24': '-6rem',
    '-28': '-7rem',
    '-32': '-8rem',
    '-36': '-9rem',
    '-40': '-10rem',
    '-44': '-11rem',
    '-48': '-12rem',
    '-52': '-13rem',
    '-56': '-14rem',
    '-60': '-15rem',
    '-64': '-16rem',
    '-72': '-18rem',
    '-80': '-20rem',
    '-96': '-24rem',
    '-px': '-1px',
    '-0.5': '-0.125rem',
    '-1.5': '-0.375rem',
    '-2.5': '-0.625rem',
    '-3.5': '-0.875rem',
  },
  stroke: { current: 'currentColor' },
  strokeWidth: { 0: '0', 1: '1', 2: '2' },
  textColor: {
    white: 'var(--white)',
    fg_primary: 'var(--fg-color-primary)',
    fg_secondary: 'var(--fg-color-secondary)',
    bg_primary: 'var(--bg-color-primary)',
    'grey-border': '#f0e9e9',
    'bg_ligth-grey-gradient': 'var(--bg-ligth-grey-gradient)',
    'grey-table-border': 'var(--grey-table-border)',
  },
  textOpacity: {
    0: '0',
    5: '0.05',
    10: '0.1',
    20: '0.2',
    25: '0.25',
    30: '0.3',
    40: '0.4',
    50: '0.5',
    60: '0.6',
    70: '0.7',
    75: '0.75',
    80: '0.8',
    90: '0.9',
    95: '0.95',
    100: '1',
  },
  transformOrigin: {
    center: 'center',
    top: 'top',
    'top-right': 'top right',
    right: 'right',
    'bottom-right': 'bottom right',
    bottom: 'bottom',
    'bottom-left': 'bottom left',
    left: 'left',
    'top-left': 'top left',
  },
  transitionDelay: {
    75: '75ms',
    100: '100ms',
    150: '150ms',
    200: '200ms',
    300: '300ms',
    500: '500ms',
    700: '700ms',
    1000: '1000ms',
  },
  transitionDuration: {
    75: '75ms',
    100: '100ms',
    150: '150ms',
    200: '200ms',
    300: '300ms',
    500: '500ms',
    700: '700ms',
    1000: '1000ms',
    DEFAULT: '150ms',
  },
  transitionProperty: {
    none: 'none',
    all: 'all',
    DEFAULT:
      'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter',
    colors: 'background-color, border-color, color, fill, stroke',
    opacity: 'opacity',
    shadow: 'box-shadow',
    transform: 'transform',
  },
  transitionTimingFunction: {
    DEFAULT: 'cubic-bezier(0.4, 0, 0.2, 1)',
    linear: 'linear',
    in: 'cubic-bezier(0.4, 0, 1, 1)',
    out: 'cubic-bezier(0, 0, 0.2, 1)',
    'in-out': 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  translate: {
    0: '0px',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
    px: '1px',
    0.5: '0.125rem',
    1.5: '0.375rem',
    2.5: '0.625rem',
    3.5: '0.875rem',
    '-0': '0px',
    '-1': '-0.25rem',
    '-2': '-0.5rem',
    '-3': '-0.75rem',
    '-4': '-1rem',
    '-5': '-1.25rem',
    '-6': '-1.5rem',
    '-7': '-1.75rem',
    '-8': '-2rem',
    '-9': '-2.25rem',
    '-10': '-2.5rem',
    '-11': '-2.75rem',
    '-12': '-3rem',
    '-14': '-3.5rem',
    '-16': '-4rem',
    '-20': '-5rem',
    '-24': '-6rem',
    '-28': '-7rem',
    '-32': '-8rem',
    '-36': '-9rem',
    '-40': '-10rem',
    '-44': '-11rem',
    '-48': '-12rem',
    '-52': '-13rem',
    '-56': '-14rem',
    '-60': '-15rem',
    '-64': '-16rem',
    '-72': '-18rem',
    '-80': '-20rem',
    '-96': '-24rem',
    '-px': '-1px',
    '-0.5': '-0.125rem',
    '-1.5': '-0.375rem',
    '-2.5': '-0.625rem',
    '-3.5': '-0.875rem',
    '1/2': '50%',
    '1/3': '33.333333%',
    '2/3': '66.666667%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    full: '100%',
    '-1/2': '-50%',
    '-1/3': '-33.333333%',
    '-2/3': '-66.666667%',
    '-1/4': '-25%',
    '-2/4': '-50%',
    '-3/4': '-75%',
    '-full': '-100%',
  },
  width: {
    0: '0px',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    11: '2.75rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    28: '7rem',
    32: '8rem',
    36: '9rem',
    40: '10rem',
    44: '11rem',
    48: '12rem',
    52: '13rem',
    56: '14rem',
    60: '15rem',
    64: '16rem',
    72: '18rem',
    80: '20rem',
    96: '24rem',
    auto: 'auto',
    px: '1px',
    0.5: '0.125rem',
    1.5: '0.375rem',
    2.5: '0.625rem',
    3.5: '0.875rem',
    '1/2': '50%',
    '1/3': '33.333333%',
    '2/3': '66.666667%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/5': '20%',
    '2/5': '40%',
    '3/5': '60%',
    '4/5': '80%',
    '1/6': '16.666667%',
    '2/6': '33.333333%',
    '3/6': '50%',
    '4/6': '66.666667%',
    '5/6': '83.333333%',
    '1/12': '8.333333%',
    '2/12': '16.666667%',
    '3/12': '25%',
    '4/12': '33.333333%',
    '5/12': '41.666667%',
    '6/12': '50%',
    '7/12': '58.333333%',
    '8/12': '66.666667%',
    '9/12': '75%',
    '10/12': '83.333333%',
    '11/12': '91.666667%',
    full: '100%',
    screen: '100vw',
    min: 'min-content',
    max: 'max-content',
  },
  zIndex: {
    0: '0',
    10: '10',
    20: '20',
    30: '30',
    40: '40',
    50: '50',
    auto: 'auto',
  },
}

export default theme
